import { Button } from 'react-bootstrap';

import { dayPT, toSchedulesFormat } from '@/services/dates';
import { IVisualSchedule } from '@/store/ducks/products/types';

import CustomModal from '../../CustomModal';

interface ProductScheduleModalProps {
  title: string;
  productSchedule: IVisualSchedule;
  show: boolean;
  onHide: () => void;
}

export function ProductScheduleModal({
  title,
  productSchedule,
  show,
  onHide,
}: ProductScheduleModalProps) {
  const today =
    toSchedulesFormat[
      new Date().toString().split(' ')[0]?.toLowerCase() as keyof typeof toSchedulesFormat
    ];
  return (
    <CustomModal centered show={show} onHide={onHide}>
      <div className="d-flex justify-content-center p-3 flex-column">
        <div className="text-center pb-3">
          <h5 className="mb-4">{title}</h5>
          <span>Disponibilidade do horário</span>
        </div>
        {Object.keys(productSchedule)
          .filter((dayKey) => dayKey !== 'isAvailable' && dayPT(dayKey))
          .map((dayKey) => (
            <div
              key={dayKey}
              className="d-flex justify-content-between w-100 my-2"
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '130%',
              }}
            >
              <span>
                {dayKey === today ? <strong>{dayPT(dayKey)} - Hoje</strong> : dayPT(dayKey)}
              </span>
              <span>{productSchedule[dayKey as keyof IVisualSchedule]}</span>
            </div>
          ))}
        <div className="d-flex justify-content-center pt-3">
          <Button variant="outline-secondary" className="w-100" onClick={onHide}>
            Fechar
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
